import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Users, ArrowRight } from 'lucide-react';
import { useLanguage } from '../i18n/LanguageContext';

const CouncilTeaser = () => {
  const { t } = useLanguage();
  const navigate = useNavigate();

  return (
    <section className="jbss-cta-section" data-testid="council-teaser-section">
      <div className="jbss-container">
        <div className="jbss-cta-card" id="council-teaser">
          <div className="jbss-cta-grid">
            <div className="jbss-cta-left">
              <span className="jbss-eyebrow jbss-eyebrow-light">
                <Users size={14} style={{ marginRight: 6, verticalAlign: 'middle' }} />
                {t('council.eyebrow')}
              </span>
              <h2 className="jbss-cta-title">{t('council.title')}</h2>
              <p className="jbss-cta-sub">{t('council.subtitle')}</p>
            </div>
            <div className="jbss-cta-actions">
              <button
                className="jbss-btn jbss-btn-gold"
                onClick={() => navigate('/governing-council')}
                data-testid="council-teaser-view-btn"
              >
                <span>{t('common.viewAll')}</span>
                <ArrowRight size={16} />
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CouncilTeaser;
